<template>
  <div>
    <form action="" class="mt-4">
      <div class="form-row">
        <div class="form-group col-12">
          <label for="user_first_name">{{ $t("invoice_note") }}</label>
          <app-input type="text-editor" v-model="invoice_note"/>
        </div>
        <div class="form-group col-12">
          <label for="user_first_name">{{ $t("banking_detail") }}</label>
          <app-input type="text-editor" :required="true" v-model="banking_detail"/>
        </div>
      </div>
      <button type="button" class="btn btn-primary mr-2" @click.prevent="updateBanner">Submit</button>
    </form>
  </div>
</template>
<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper";
import {UPDATE_BANKING_DETAIL} from "../../../../app/Config/ApiUrl";

export default {
  mixins: [FormMixin],
  data() {
    return {
      //   readOnly: true,
      setModal: false,
      invoice_note: '',
      banking_detail: '',
      info: {},
      
    };
  },
  computed: {
    appSettings(){
      return this.$store.state.settings;
    }
  },
  watch:{

  },
  mounted() {

    this.invoice_note = this.appSettings.appSettings.invoice_note;
    this.banking_detail = this.appSettings.appSettings.banking_detail;
  },
  methods: {
    updateBanner(){
  
        this.info = {
          'invoice_note': this.invoice_note,
          'banking_detail': this.banking_detail,
        }
        axiosPost(UPDATE_BANKING_DETAIL, this.info)
          .then((res) => {

            if (res.data.message) {
              this.$toastr.s(res.data.message);
            }
            else {
            this.$toastr.w(res.data.info);
            }
            this.setModal = false;
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            location.reload();
            this.preloader = false;
          });
      }
      // this.setModal = false;
    },
  }
</script>